"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentDetailsSchema = exports.paymentDetailsInitalized = void 0;
const joi_1 = __importDefault(require("joi"));
exports.paymentDetailsInitalized = {
    teyaPublicKeyTest: '',
    teyaPrivateKeyTest: '',
    vendorIdTest: '',
    borgunMerchantIdTest: '',
    borgunSecretKeyTest: '',
    teyaPublicKey: '',
    teyaPrivateKey: '',
    vendorId: '',
    borgunMerchantId: '',
    borgunSecretKey: '',
    authorizationKey: '',
    siteEntityId: '',
    serialNumber: '',
    POIID: '',
    SaleID: '',
};
exports.paymentDetailsSchema = joi_1.default.object({
    teyaPublicKeyTest: joi_1.default.any().allow(''),
    teyaPrivateKeyTest: joi_1.default.any().allow(''),
    vendorIdTest: joi_1.default.any().allow(''),
    borgunMerchantIdTest: joi_1.default.any().allow(''),
    borgunSecretKeyTest: joi_1.default.any().allow(''),
    teyaPublicKey: joi_1.default.any().allow(''),
    teyaPrivateKey: joi_1.default.any().allow(''),
    vendorId: joi_1.default.any().allow(''),
    borgunMerchantId: joi_1.default.any().allow(''),
    borgunSecretKey: joi_1.default.any().allow(''),
    authorizationKey: joi_1.default.any().allow(''),
    siteEntityId: joi_1.default.any().allow(''),
    serialNumber: joi_1.default.any().allow(''),
    POIID: joi_1.default.any().allow(''),
    SaleID: joi_1.default.any().allow(''),
});
